import {
  Box,
  CircularProgress,
  Typography,
  Backdrop,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Z_INDEX } from "../styles/zIndex";

/** Ignore brief socket blips so the POS does not flash this overlay. */
const SHOW_AFTER_MS = 1500;

const OfflineScreen = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handle = window.setTimeout(() => setVisible(true), SHOW_AFTER_MS);
    return () => window.clearTimeout(handle);
  }, []);

  if (!visible) return null;

  return (
    <Backdrop
      open
      sx={{
        color: "#fff",
        zIndex: Z_INDEX.offline,
        flexDirection: "column",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
      }}
    >
      <CircularProgress size={60} thickness={4} color="inherit" />
      <Box sx={{ mt: 3, textAlign: "center" }}>
        <Typography variant="h5" component="h2">
          {t("common:status.systemOffline")}
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.8 }}>
          {t("common:status.pleaseWait")}
        </Typography>
      </Box>
    </Backdrop>
  );
};

export default OfflineScreen;
